<template>
    <div>
        <no-internet-explorer v-if="showIEMessage" @close="closeIEMessage"></no-internet-explorer>
        
        <vue-progress-bar></vue-progress-bar>

        <div class="app__progress-bar-background" v-if="isFetchingReservationByID"></div>
        <richPrompt v-if="getShowRichPrompt"></richPrompt>

        <upgrade-plan-popup></upgrade-plan-popup>

        <something-went-wrong-popup></something-went-wrong-popup>

        <full-screen-loader :active="getFullScreenLoading"></full-screen-loader>
       
        <div class="app" :class="{ blurry: getFullScreenLoading }">
            <notifications position="bottom right" group="notifications" />

            <component :is="layout"></component>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import Teaser from './components/layouts/Teaser'
    import Auth from './components/layouts/Auth'
    import Error from './components/layouts/Error'
    import Basic from './components/layouts/Basic'
    import Pluralo from './components/layouts/Pluralo'
    import Loading from './components/layouts/Loading'
    import FullScreenLoader from './tools/fullScreenLoader/FullScreenLoader'
    import UpgradePlanPopup from './components/other/UpgradePlanPopup'
    import SomethingWentWrongPopup from './components/other/SomethingWentWrong'
    import RichPrompt from '@/tools/richPrompt/richPrompt'
    import NoInternetExplorer from './components/other/noInternetExplorer'

    export default {
        data() {
            return {
                showIEMessage: false,
                isFetchingReservationByID: false
            }
        },
        created() {
            let vm = this;

            // if client is Internet Explorer (shame on them) display a friendly message
            this.setIEMessageVisibility();

            // Download global stuff that not requires auth
            this.init();

            // Check if user is Supplier and is loggedin or not, or if it is agent
            this.checkUser({
                route: this.$route
            }).then(response => {
                if (response != 'agent') {
                    vm.switchLayout(this.stripLayoutNameFromRoutePrefix(this.$route.name));
                }
            })
        },
        computed: {
            ...mapGetters([
                'layout',
                'getFullScreenLoading',
                'getShowRichPrompt'
            ])
        },
        methods: {
            ...mapActions([
                'switchLayout',
                'initGeography',
                'checkUser'
            ]),
            setIEMessageVisibility() {
                const ua = window.navigator.userAgent;

                const msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }

                const trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    this.showIEMessage = true
                    const rv = ua.indexOf('rv:');
                    
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }

                const edge = ua.indexOf('Edge/');
                if (edge > 0) {
                   // Edge (IE 12+) => return version number
                   return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }

                // other browser
                return false;
            },
            stripLayoutNameFromRoutePrefix(route) {
                return route ? route.substring(0, route.indexOf('.')) : '';
            },
            init() {
                this.initGeography();
            },
            closeIEMessage() {
                this.showIEMessage = false;
            }
        },
        components: {
            Teaser,
            Pluralo,
            Auth,
            Error,
            Basic,
            FullScreenLoader,
            Loading,
            UpgradePlanPopup,
            SomethingWentWrongPopup,
            RichPrompt,
            NoInternetExplorer
        },
        watch: {
            '$route' (to, from) {
                this.switchLayout(this.stripLayoutNameFromRoutePrefix(to.name));
            }
        },
        mounted() {
            this.eventHub.$on('loading',(isLoading) => {
                if (isLoading) {
                    this.isFetchingReservationByID = true;
                } else {
                    this.isFetchingReservationByID = false;
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '/assets/scss/_variables.scss';
    
    .app {
        background: $background;
        transition: all ease-in-out 200px;
        
        &.blurry {
            filter:blur(5px);
        }
    }

    .app__progress-bar-background {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 5px;
        left: 0;
        z-index: 999;
        background: $background-transparent;
        filter:blur(5px);
    }
</style>



// WEBPACK FOOTER //
// App.vue?42679b86